import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { INavigationConfig, NavigationConfig } from '../utils/navigation-constants';
import { openToast } from '../store/reducers/toastSlice';

const SocialLoginAuthCallback = () => {
    const navigate = useNavigate();
    const navConfig: INavigationConfig = NavigationConfig;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    React.useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const error = urlParams.get('error_description');
        switch (error) {
            case 'PreSignUp failed with error user not found. ':
                dispatch(
                    openToast({
                        show: true,
                        message: t('pre_signup_error_message'),
                        severity: 'error',
                        isAlertOpen: true,
                    }),
                );
                setTimeout(() => {
                    navigate(navConfig.Login, { state: { error } });
                }, 0);
                break;
            case "PreSignUp failed with error User doesn't have access to this app. ":
                dispatch(
                    openToast({
                        show: true,
                        message: t('user_has_no_access_error'),
                        severity: 'error',
                        isAlertOpen: true,
                    }),
                );
                setTimeout(() => {
                    navigate(navConfig.Login, { state: { error } });
                }, 0);
                break;
            default:
        }
    }, [navigate, dispatch, navConfig.Login, t]);
};

export default SocialLoginAuthCallback;
